import { useState } from "react";
import {
  getDataService,
  getFetchFaults,
  getFetchPdf,
  getOrdersCurrent,
  getOrdersResolved,
  getAction,
} from "../../controllers/APIDataCallController/APIDataCallController";
import { getLocationStrict } from "../../helpers/getLocationStrict";

const LOGIN_STEP = {
  IDLE: "IDLE",
  TELEGRAM: "TELEGRAM",
  USER_CHECK: "USER_CHECK",
  LOCATION: "LOCATION",
  LOAD_DATA: "LOAD_DATA",
  READY: "READY",
  ERROR: "ERROR",
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function useLoginFlow({
  setUserLocation,
  setMarkers,
  setArchive,
  setFetchFaults,
  setOrdersCurrent,
  setOrdersResolved,
  setFetchPdf,
  navigate,
  setIsLoadUserId,
  setUndefinedUserId,
  setAction,
}) {
  const [step, setStep] = useState(LOGIN_STEP.IDLE);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);

  const start = async () => {
    try {
      await delay(2000);

      setStep(LOGIN_STEP.LOCATION);
      setMessage("Определение местоположения...");

      const location = await getLocationStrict();

      setUserLocation(location);

      setStep(LOGIN_STEP.LOAD_DATA);
      setMessage("Загрузка данных...");

      await Promise.all([
        getDataService(setMarkers, setArchive),
        getFetchFaults(setFetchFaults),
        getOrdersCurrent(setOrdersCurrent),
        getOrdersResolved(setOrdersResolved),
        getFetchPdf(setFetchPdf),
      ]);
      const action = await getAction();
      setAction(action);
      await delay(2000);

      /** READY */
      setStep(LOGIN_STEP.READY);
      setMessage("Вход в систему");
      setIsLoadUserId(true);
      await delay(3000);

      navigate("/");
    } catch (e) {
      // console.error("[LOGIN FLOW ERROR]", e);
      // setError(e.message);
      // setStep(LOGIN_STEP.ERROR);
      // setMessage(e.message);
    }
  };

  return { step, message, error, start };
}
